import axios from '@/axios';

export async function getDiagnostics(params) {
    try {
        const { data } = await axios.get("/diagnostics/filter", { params });
        return data.data ? data.data : data;
    } catch (error) {
        return { error };
    }
}

export async function saveDiagnostic(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/diagnostics/${id}` : '/diagnostics/create';
    return await axios({ method, url, data: data });
}
 
